import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'
function Heading(props){
  const [orderStr] = useEnvValue('strings.order','Bestilling')

  const product = props.product
  return (
    <>
      {props.excludeTitle ? null : <h1 className={'product_title entry-title'}>{product.name}</h1>}
      <p className="summary-form-title">{orderStr}</p>
    </>
  )
}
Heading.defaultProps = {
  excludeTitle: false
}
export default Heading